// Care Guide Accordion Logic
document.addEventListener('DOMContentLoaded', () => {
  // Top-level sections (Clean, Store, Essentials)
  document.querySelectorAll('.care-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const section = trigger.closest('.care-section');
      if (section) {
        section.classList.toggle('open');
      }
    });
  });

  // Sub-accordions (9K Gold, Coloured Stones)
  document.querySelectorAll('.sub-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.sub-acc-item');
      if (item) {
        item.classList.toggle('open');
      }
    });
  });
});
